import '@fontsource/barlow/300.css'
import '@fontsource/barlow/400.css'
import '@fontsource/barlow/500.css'
import '@fontsource/barlow/700.css'
import '@mui/material/types/OverridableComponentAugmentation'
import { useGLTF } from '@react-three/drei'
import { ApplicationTypes } from 'awr-domain'

import { initConsoleLogger } from '@salsita-ai/platform-common/utils'
import { mountConfiguratorApplication } from '@salsita-ai/platform-project-sdk/application'

import { config } from './config.js'
import { getResourceUrl } from './systems/resources.js'

useGLTF.preload(getResourceUrl('/models/main.glb'))
useGLTF.preload(getResourceUrl('/models/materials.glb'))
useGLTF.preload(getResourceUrl('/models/wire-balustrade-systems.glb'))

setTimeout(() => {
  useGLTF.preload(getResourceUrl('/models/handrails-fitting-round.glb'))
  useGLTF.preload(getResourceUrl('/models/handrails-fitting-square.glb'))
  useGLTF.preload(getResourceUrl('/models/posts-aluminium.glb'))
  useGLTF.preload(getResourceUrl('/models/posts-stainless-steel.glb'))
}, 3000)

const logger = initConsoleLogger()

logger.info(`Starting configurator with release version ${ApplicationTypes.ApplicationVersion}`, {
  applicationVersion: ApplicationTypes.ApplicationVersion,
})

mountConfiguratorApplication(config)
